import React, { memo, useMemo } from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getChannelId, sortChannelsByLastMessageTime } from '../TeamChat.utils';
import TeamChatChannelListItem from '../TeamChatChannelListItem';

import { TEAM_CHAT_CHANNEL_LIST_EMPTY_LABEL } from './TeamChatChannelList.constants';
import { emptyStyles, loadingStyles, rootStyles } from './TeamChatChannelList.styles';

const TeamChatChannelList = memo(
  ({ channels, activeChannelId = null, onSelectChannel, isLoading = false }) => {
    const sortedChannels = useMemo(() => sortChannelsByLastMessageTime(channels), [channels]);

    if (isLoading && !sortedChannels.length) {
      return (
        <Box sx={rootStyles}>
          <Box sx={loadingStyles}>
            <CircularProgress size={20} />
          </Box>
        </Box>
      );
    }

    if (!sortedChannels.length) {
      return (
        <Box sx={rootStyles}>
          <Box sx={emptyStyles}>
            <Typography variant="regular14">{TEAM_CHAT_CHANNEL_LIST_EMPTY_LABEL}</Typography>
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={rootStyles}>
        {sortedChannels.map(channel => {
          const chatId = getChannelId(channel);

          return (
            <TeamChatChannelListItem
              channel={channel}
              isActive={chatId === activeChannelId}
              key={chatId}
              onSelect={onSelectChannel}
            />
          );
        })}
      </Box>
    );
  },
);
TeamChatChannelList.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectChannel: PropTypes.func.isRequired,
  activeChannelId: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default TeamChatChannelList;
